import { atom, selector } from 'recoil';
import {
  menus,
  menuEstudiante,
  menuAsesor,
  menuCoordinador,
} from '@/configs/menus';
import { verificarToken, getTokenData } from './storage';
import Roles from '@/components/role/roles';

export const menuEffect =
  () =>
  ({ trigger, onSet, setSelf }) => {
    const token = localStorage.getItem('tokenEcosurEstudiantesExternos');
    if (trigger === 'get' && token && verificarToken(token)) {
      var tokenData = getTokenData(token);
      switch (tokenData.role as Roles) {
        case Roles.Estudiante:
          setSelf(menuEstudiante);
          break;
        case Roles.Asesor:
          setSelf(menuAsesor);
          break;
        case Roles.Coordinador:
          setSelf(menuCoordinador);
          break;
      }
    }
    onSet((newValue: any) => {
      if (token && verificarToken(token)) {
        setSelf(newValue);
      } else {
        setSelf(menus);
      }
    });
  };

export const menuState = atom({
  key: 'menuState',
  default: menus,
  effects: [menuEffect()],
});

export const menuInfo = selector({
  key: 'menuInfo',
  get: ({ get }) => ({
    opciones: get(menuState),
  }),
});
